import type { Language } from "@/types";

// ─────────────────────────────────────────────
// pickLocalized — schema-content localization
//
// Schema content (question text, option labels, posture/domain names) is
// stored bilingually in the DB (text + textSr, label + labelSr, name +
// nameSr). UI chrome goes through t()/locale JSONs; DB content goes through
// this helper: prefer the Serbian variant when the UI locale is Serbian and
// a translation exists, otherwise fall back to the English/base text.
// ─────────────────────────────────────────────

export function pickLocalized(
  base: string | null | undefined,
  sr: string | null | undefined,
  language: Language,
): string {
  return language === "sr" && sr ? sr : (base ?? "");
}
